/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PaginatedUserList } from '../models/PaginatedUserList';
import type { PaginatedUserPreferencesList } from '../models/PaginatedUserPreferencesList';
import type { PaginatedUserPreferencesSerializerWithReprList } from '../models/PaginatedUserPreferencesSerializerWithReprList';
import type { PaginatedUserSerializerWithReprList } from '../models/PaginatedUserSerializerWithReprList';
import type { PatchedUserPreferencesSerializerWithRepr } from '../models/PatchedUserPreferencesSerializerWithRepr';
import type { PatchedUserSerializerWithRepr } from '../models/PatchedUserSerializerWithRepr';
import type { RecentOrganisations } from '../models/RecentOrganisations';
import type { Token } from '../models/Token';
import type { User } from '../models/User';
import type { UserPreferences } from '../models/UserPreferences';
import type { UserPreferencesSerializerWithRepr } from '../models/UserPreferencesSerializerWithRepr';
import type { UserSerializerWithRepr } from '../models/UserSerializerWithRepr';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class UsersService {
    /**
     * @returns PaginatedUserList
     * @throws ApiError
     */
    public static usersList({
        belongsTo,
        email,
        excludeFields,
        fields,
        firstName,
        incorrectLoginAttempts,
        isActive,
        isSuperuser,
        lastName,
        limit,
        offset,
        ordering,
        password,
        profileColor,
        readDepth,
        search,
        twoFactorAuthMode,
    }: {
        belongsTo?: Array<string>,
        email?: Array<string>,
        excludeFields?: Array<string>,
        fields?: Array<string>,
        firstName?: Array<string>,
        incorrectLoginAttempts?: Array<string>,
        isActive?: Array<string>,
        isSuperuser?: Array<string>,
        lastName?: Array<string>,
        /**
         * Number of results to return per page.
         */
        limit?: number,
        /**
         * The initial index from which to return the results.
         */
        offset?: number,
        /**
         * Which field to use when ordering the results.
         */
        ordering?: string,
        password?: Array<string>,
        profileColor?: Array<string>,
        readDepth?: number,
        /**
         * A search term.
         */
        search?: string,
        twoFactorAuthMode?: Array<string>,
    }): CancelablePromise<PaginatedUserList> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/users/',
            query: {
                'belongs_to': belongsTo,
                'email': email,
                'exclude-fields': excludeFields,
                'fields': fields,
                'first_name': firstName,
                'incorrect_login_attempts': incorrectLoginAttempts,
                'is_active': isActive,
                'is_superuser': isSuperuser,
                'last_name': lastName,
                'limit': limit,
                'offset': offset,
                'ordering': ordering,
                'password': password,
                'profile_color': profileColor,
                'read_depth': readDepth,
                'search': search,
                'two_factor_auth_mode': twoFactorAuthMode,
            },
        });
    }
    /**
     * @returns UserSerializerWithRepr
     * @throws ApiError
     */
    public static usersCreate({
        requestBody,
    }: {
        requestBody: UserSerializerWithRepr,
    }): CancelablePromise<UserSerializerWithRepr> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/users/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns PaginatedUserSerializerWithReprList
     * @throws ApiError
     */
    public static userBulkUpdate({
        requestBody,
        belongsTo,
        email,
        excludeFields,
        fields,
        firstName,
        incorrectLoginAttempts,
        isActive,
        isSuperuser,
        lastName,
        limit,
        offset,
        ordering,
        password,
        profileColor,
        readDepth,
        search,
        twoFactorAuthMode,
    }: {
        requestBody: Array<UserSerializerWithRepr>,
        belongsTo?: Array<string>,
        email?: Array<string>,
        excludeFields?: Array<string>,
        fields?: Array<string>,
        firstName?: Array<string>,
        incorrectLoginAttempts?: Array<string>,
        isActive?: Array<string>,
        isSuperuser?: Array<string>,
        lastName?: Array<string>,
        /**
         * Number of results to return per page.
         */
        limit?: number,
        /**
         * The initial index from which to return the results.
         */
        offset?: number,
        /**
         * Which field to use when ordering the results.
         */
        ordering?: string,
        password?: Array<string>,
        profileColor?: Array<string>,
        readDepth?: number,
        /**
         * A search term.
         */
        search?: string,
        twoFactorAuthMode?: Array<string>,
    }): CancelablePromise<PaginatedUserSerializerWithReprList> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/users/',
            query: {
                'belongs_to': belongsTo,
                'email': email,
                'exclude-fields': excludeFields,
                'fields': fields,
                'first_name': firstName,
                'incorrect_login_attempts': incorrectLoginAttempts,
                'is_active': isActive,
                'is_superuser': isSuperuser,
                'last_name': lastName,
                'limit': limit,
                'offset': offset,
                'ordering': ordering,
                'password': password,
                'profile_color': profileColor,
                'read_depth': readDepth,
                'search': search,
                'two_factor_auth_mode': twoFactorAuthMode,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns PaginatedUserSerializerWithReprList
     * @throws ApiError
     */
    public static userBulkPartialUpdate({
        requestBody,
        belongsTo,
        email,
        excludeFields,
        fields,
        firstName,
        incorrectLoginAttempts,
        isActive,
        isSuperuser,
        lastName,
        limit,
        offset,
        ordering,
        password,
        profileColor,
        readDepth,
        search,
        twoFactorAuthMode,
    }: {
        requestBody: Array<UserSerializerWithRepr>,
        belongsTo?: Array<string>,
        email?: Array<string>,
        excludeFields?: Array<string>,
        fields?: Array<string>,
        firstName?: Array<string>,
        incorrectLoginAttempts?: Array<string>,
        isActive?: Array<string>,
        isSuperuser?: Array<string>,
        lastName?: Array<string>,
        /**
         * Number of results to return per page.
         */
        limit?: number,
        /**
         * The initial index from which to return the results.
         */
        offset?: number,
        /**
         * Which field to use when ordering the results.
         */
        ordering?: string,
        password?: Array<string>,
        profileColor?: Array<string>,
        readDepth?: number,
        /**
         * A search term.
         */
        search?: string,
        twoFactorAuthMode?: Array<string>,
    }): CancelablePromise<PaginatedUserSerializerWithReprList> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/users/',
            query: {
                'belongs_to': belongsTo,
                'email': email,
                'exclude-fields': excludeFields,
                'fields': fields,
                'first_name': firstName,
                'incorrect_login_attempts': incorrectLoginAttempts,
                'is_active': isActive,
                'is_superuser': isSuperuser,
                'last_name': lastName,
                'limit': limit,
                'offset': offset,
                'ordering': ordering,
                'password': password,
                'profile_color': profileColor,
                'read_depth': readDepth,
                'search': search,
                'two_factor_auth_mode': twoFactorAuthMode,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns void
     * @throws ApiError
     */
    public static userBulkDestroy({
        id,
    }: {
        id?: Array<number>,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/users/',
            query: {
                'id': id,
            },
        });
    }
    /**
     * @returns User
     * @throws ApiError
     */
    public static usersRetrieve({
        id,
        belongsTo,
        email,
        excludeFields,
        fields,
        firstName,
        incorrectLoginAttempts,
        isActive,
        isSuperuser,
        lastName,
        password,
        profileColor,
        readDepth,
        twoFactorAuthMode,
    }: {
        /**
         * A unique integer value identifying this user.
         */
        id: number,
        belongsTo?: Array<string>,
        email?: Array<string>,
        excludeFields?: Array<string>,
        fields?: Array<string>,
        firstName?: Array<string>,
        incorrectLoginAttempts?: Array<string>,
        isActive?: Array<string>,
        isSuperuser?: Array<string>,
        lastName?: Array<string>,
        password?: Array<string>,
        profileColor?: Array<string>,
        readDepth?: number,
        twoFactorAuthMode?: Array<string>,
    }): CancelablePromise<User> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/users/{id}/',
            path: {
                'id': id,
            },
            query: {
                'belongs_to': belongsTo,
                'email': email,
                'exclude-fields': excludeFields,
                'fields': fields,
                'first_name': firstName,
                'incorrect_login_attempts': incorrectLoginAttempts,
                'is_active': isActive,
                'is_superuser': isSuperuser,
                'last_name': lastName,
                'password': password,
                'profile_color': profileColor,
                'read_depth': readDepth,
                'two_factor_auth_mode': twoFactorAuthMode,
            },
        });
    }
    /**
     * @returns UserSerializerWithRepr
     * @throws ApiError
     */
    public static usersUpdate({
        id,
        requestBody,
    }: {
        /**
         * A unique integer value identifying this user.
         */
        id: number,
        requestBody: UserSerializerWithRepr,
    }): CancelablePromise<UserSerializerWithRepr> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/users/{id}/',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns UserSerializerWithRepr
     * @throws ApiError
     */
    public static usersPartialUpdate({
        id,
        requestBody,
    }: {
        /**
         * A unique integer value identifying this user.
         */
        id: number,
        requestBody?: PatchedUserSerializerWithRepr,
    }): CancelablePromise<UserSerializerWithRepr> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/users/{id}/',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns void
     * @throws ApiError
     */
    public static usersDestroy({
        id,
    }: {
        /**
         * A unique integer value identifying this user.
         */
        id: number,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/users/{id}/',
            path: {
                'id': id,
            },
        });
    }
    /**
     * @returns User
     * @throws ApiError
     */
    public static usersReset2FaUpdate({
        id,
    }: {
        /**
         * A unique integer value identifying this user.
         */
        id: number,
    }): CancelablePromise<User> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/users/{id}/reset_2fa/',
            path: {
                'id': id,
            },
        });
    }
    /**
     * Unlock a locked account
     * @returns User
     * @throws ApiError
     */
    public static usersUnlockAccountUpdate({
        id,
        requestBody,
    }: {
        /**
         * A unique integer value identifying this user.
         */
        id: number,
        requestBody: User,
    }): CancelablePromise<User> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/users/{id}/unlock_account/',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns PaginatedUserPreferencesList
     * @throws ApiError
     */
    public static usersPreferencesList({
        usersPk,
        config,
        excludeFields,
        fields,
        _interface,
        limit,
        offset,
        ordering,
        readDepth,
        search,
        user,
    }: {
        usersPk: string,
        config?: Array<string>,
        excludeFields?: Array<string>,
        fields?: Array<string>,
        _interface?: Array<string>,
        /**
         * Number of results to return per page.
         */
        limit?: number,
        /**
         * The initial index from which to return the results.
         */
        offset?: number,
        /**
         * Which field to use when ordering the results.
         */
        ordering?: string,
        readDepth?: number,
        /**
         * A search term.
         */
        search?: string,
        user?: Array<string>,
    }): CancelablePromise<PaginatedUserPreferencesList> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/users/{users_pk}/preferences/',
            path: {
                'users_pk': usersPk,
            },
            query: {
                'config': config,
                'exclude-fields': excludeFields,
                'fields': fields,
                'interface': _interface,
                'limit': limit,
                'offset': offset,
                'ordering': ordering,
                'read_depth': readDepth,
                'search': search,
                'user': user,
            },
        });
    }
    /**
     * @returns UserPreferencesSerializerWithRepr
     * @throws ApiError
     */
    public static usersPreferencesCreate({
        usersPk,
        requestBody,
    }: {
        usersPk: string,
        requestBody: UserPreferencesSerializerWithRepr,
    }): CancelablePromise<UserPreferencesSerializerWithRepr> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/users/{users_pk}/preferences/',
            path: {
                'users_pk': usersPk,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns PaginatedUserPreferencesSerializerWithReprList
     * @throws ApiError
     */
    public static userPreferencesBulkUpdate({
        usersPk,
        requestBody,
        config,
        excludeFields,
        fields,
        _interface,
        limit,
        offset,
        ordering,
        readDepth,
        search,
        user,
    }: {
        usersPk: string,
        requestBody: Array<UserPreferencesSerializerWithRepr>,
        config?: Array<string>,
        excludeFields?: Array<string>,
        fields?: Array<string>,
        _interface?: Array<string>,
        /**
         * Number of results to return per page.
         */
        limit?: number,
        /**
         * The initial index from which to return the results.
         */
        offset?: number,
        /**
         * Which field to use when ordering the results.
         */
        ordering?: string,
        readDepth?: number,
        /**
         * A search term.
         */
        search?: string,
        user?: Array<string>,
    }): CancelablePromise<PaginatedUserPreferencesSerializerWithReprList> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/users/{users_pk}/preferences/',
            path: {
                'users_pk': usersPk,
            },
            query: {
                'config': config,
                'exclude-fields': excludeFields,
                'fields': fields,
                'interface': _interface,
                'limit': limit,
                'offset': offset,
                'ordering': ordering,
                'read_depth': readDepth,
                'search': search,
                'user': user,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns PaginatedUserPreferencesSerializerWithReprList
     * @throws ApiError
     */
    public static userPreferencesBulkPartialUpdate({
        usersPk,
        requestBody,
        config,
        excludeFields,
        fields,
        _interface,
        limit,
        offset,
        ordering,
        readDepth,
        search,
        user,
    }: {
        usersPk: string,
        requestBody: Array<UserPreferencesSerializerWithRepr>,
        config?: Array<string>,
        excludeFields?: Array<string>,
        fields?: Array<string>,
        _interface?: Array<string>,
        /**
         * Number of results to return per page.
         */
        limit?: number,
        /**
         * The initial index from which to return the results.
         */
        offset?: number,
        /**
         * Which field to use when ordering the results.
         */
        ordering?: string,
        readDepth?: number,
        /**
         * A search term.
         */
        search?: string,
        user?: Array<string>,
    }): CancelablePromise<PaginatedUserPreferencesSerializerWithReprList> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/users/{users_pk}/preferences/',
            path: {
                'users_pk': usersPk,
            },
            query: {
                'config': config,
                'exclude-fields': excludeFields,
                'fields': fields,
                'interface': _interface,
                'limit': limit,
                'offset': offset,
                'ordering': ordering,
                'read_depth': readDepth,
                'search': search,
                'user': user,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns void
     * @throws ApiError
     */
    public static userPreferencesBulkDestroy({
        usersPk,
        id,
    }: {
        usersPk: string,
        id?: Array<number>,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/users/{users_pk}/preferences/',
            path: {
                'users_pk': usersPk,
            },
            query: {
                'id': id,
            },
        });
    }
    /**
     * @returns UserPreferences
     * @throws ApiError
     */
    public static usersPreferencesRetrieve({
        id,
        usersPk,
        config,
        excludeFields,
        fields,
        _interface,
        readDepth,
        user,
    }: {
        /**
         * A unique integer value identifying this user preferences.
         */
        id: number,
        usersPk: string,
        config?: Array<string>,
        excludeFields?: Array<string>,
        fields?: Array<string>,
        _interface?: Array<string>,
        readDepth?: number,
        user?: Array<string>,
    }): CancelablePromise<UserPreferences> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/users/{users_pk}/preferences/{id}/',
            path: {
                'id': id,
                'users_pk': usersPk,
            },
            query: {
                'config': config,
                'exclude-fields': excludeFields,
                'fields': fields,
                'interface': _interface,
                'read_depth': readDepth,
                'user': user,
            },
        });
    }
    /**
     * @returns UserPreferencesSerializerWithRepr
     * @throws ApiError
     */
    public static usersPreferencesUpdate({
        id,
        usersPk,
        requestBody,
    }: {
        /**
         * A unique integer value identifying this user preferences.
         */
        id: number,
        usersPk: string,
        requestBody: UserPreferencesSerializerWithRepr,
    }): CancelablePromise<UserPreferencesSerializerWithRepr> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/users/{users_pk}/preferences/{id}/',
            path: {
                'id': id,
                'users_pk': usersPk,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns UserPreferencesSerializerWithRepr
     * @throws ApiError
     */
    public static usersPreferencesPartialUpdate({
        id,
        usersPk,
        requestBody,
    }: {
        /**
         * A unique integer value identifying this user preferences.
         */
        id: number,
        usersPk: string,
        requestBody?: PatchedUserPreferencesSerializerWithRepr,
    }): CancelablePromise<UserPreferencesSerializerWithRepr> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/users/{users_pk}/preferences/{id}/',
            path: {
                'id': id,
                'users_pk': usersPk,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns void
     * @throws ApiError
     */
    public static usersPreferencesDestroy({
        id,
        usersPk,
    }: {
        /**
         * A unique integer value identifying this user preferences.
         */
        id: number,
        usersPk: string,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/users/{users_pk}/preferences/{id}/',
            path: {
                'id': id,
                'users_pk': usersPk,
            },
        });
    }
    /**
     * Performs Read / Create / Update operations for a users recent organisations
     * @returns UserPreferences
     * @throws ApiError
     */
    public static usersPreferencesRecentOrganisationsRetrieve({
        usersPk,
    }: {
        usersPk: string,
    }): CancelablePromise<UserPreferences> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/users/{users_pk}/preferences/recent_organisations/',
            path: {
                'users_pk': usersPk,
            },
        });
    }
    /**
     * Performs Read / Create / Update operations for a users recent organisations
     * @returns UserPreferences
     * @throws ApiError
     */
    public static usersPreferencesRecentOrganisationsCreate({
        usersPk,
        requestBody,
    }: {
        usersPk: string,
        requestBody: RecentOrganisations,
    }): CancelablePromise<UserPreferences> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/users/{users_pk}/preferences/recent_organisations/',
            path: {
                'users_pk': usersPk,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns Token
     * @throws ApiError
     */
    public static usersHomeRetrieve(): CancelablePromise<Token> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/users/home/',
        });
    }
}
